import React from "react";
import "./App.css";
import BroadRoutes from "./routes/BroadRoutes";
import HeaderComponent from "./component/headercomponent/HeaderComponent";
import FooterComponent from "./component/footercomponent/FooterComponent";
import { BrowserRouter } from "react-router-dom";
import GlobalCtaButtons from "./component/GlobalCtaButtons";

function App() {
	return (
		<>
			<BrowserRouter>
				<HeaderComponent />
				<GlobalCtaButtons />
				<BroadRoutes />
				<FooterComponent />
			</BrowserRouter>
		</>
	);
}

export default App;
